import { useRefetchQuery } from "libs/reactQuery";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { Modal } from "ui";

import { useDeleteSpecialOffer } from "../../apis";
import { DeleteOfferModalProps } from "./DeleteOfferModal.types";

const DeleteOfferModal = ({
  isOpen,
  onClose,
  onCloseParentModal,
  offerId
}: DeleteOfferModalProps) => {
  const { t } = useTranslation();
  const refetchOffers = useRefetchQuery(["special-offers"]);

  const { mutate: mutateDeleteOffer, isLoading: isLoadingDeleteOffer } =
    useDeleteSpecialOffer({
      onSuccess: () => {
        refetchOffers();
        onClose();
        onCloseParentModal?.();
        toast.success(t("Special Offer was deleted successfully"));
      }
    });

  const onDeleteOffer = () => {
    if (offerId) mutateDeleteOffer(offerId);
  };

  return (
    <Modal
      type="delete"
      isOpen={isOpen}
      isLoading={isLoadingDeleteOffer}
      title="Delete Offer"
      okText="Delete"
      onClose={onClose}
      onOk={onDeleteOffer}
    >
      Are you sure tou want to delete offer?
    </Modal>
  );
};

export default DeleteOfferModal;
